exports.default = {
  'terms_title': 'Terms of Service',
  'privacy_title': 'Privacy Policy',
  'back': 'Back',
  'back_home': 'Back to home',
  'document_navigation': 'Legal documents',
  'start_using': 'Get started'
}
